import { Compass } from 'lucide-react';

import { StateLink, StatePage, StateButton } from './StatePage';

export function NotFoundPage() {
  return (
    <StatePage
      code="404"
      icon={Compass}
      tone="neutral"
      title="הדף לא נמצא"
      body="ייתכן שהקישור פג תוקף או שהדף הועבר. נסה לחזור לדף הבית או להשתמש בחיפוש (Ctrl+K)."
      primary={<StateLink to="/">חזור לדף הבית</StateLink>}
      secondary={
        <StateButton onClick={() => { window.history.back(); }}>
          חזור אחורה
        </StateButton>
      }
    />
  );
}
